import { render, staticRenderFns } from "./ProfessionDetails.vue?vue&type=template&id=0129017d"
import script from "./ProfessionDetails.vue?vue&type=script&lang=js"
export * from "./ProfessionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports